import { hFetch } from './hFetch';

export const deleteAttachment = async ({ id }: { id: string | number }) => {
  return (await hFetch({ url: `/api/attachments/${id}`, method: 'DELETE' })) as {
    status: 'success' | 'error';
    message: string;
  };
};
